import { useQuery } from '@tanstack/react-query'
import { api } from '@/shared/api/client'
import { queryKeys } from '@/shared/api/queryKeys'
import type { Stats } from '@/shared/api/types'

/**
 * Сводка по звонкам за период.
 *
 * Считается на сервере, а не из списка звонков: список приходит с
 * лимитом, и посчитанная по нему статистика была бы статистикой
 * последних пятидесяти разговоров. Такая цифра хуже, чем никакой, — она
 * выглядит настоящей.
 */
export function useStats(days: number) {
  return useQuery({
    queryKey: [...queryKeys.stats, days],
    queryFn: ({ signal }) => api.get<Stats>(`/stats?days=${days}`, signal),
    // Минуту не перезапрашиваем: сводка меняется от звонка к звонку, а
    // не от секунды к секунде.
    staleTime: 60_000,
  })
}
